/**
 * Slug of the published SurveyJS definition the summary's How did we do? thumbs submit
 * against. Must match the survey created through the admin API; the app fetches the
 * current version by this slug.
 */
export const INQUIRY_SUMMARY_HELPFUL_SURVEY_SLUG = 'inquiry-summary-helpful';

/**
 * SurveyJS question name in the `inquiry-summary-helpful` schema. A vote records
 * `{ [HELPFUL]: 'up' | 'down' }`. It must match the definition's element name and
 * choices or the backend rejects the answers as failing validation.
 */
export const INQUIRY_SUMMARY_HELPFUL_ANSWER_FIELD = 'helpful';

/**
 * Subject stamped on each vote so it ties to the post the reader rated. The id is the
 * post's own id. The post rather than its inquiry, because the post is what was read
 * and the post screen does not receive the inquiry's id.
 */
export const INQUIRY_SUMMARY_SUBJECT_TYPE = 'community_post';
